<template>
<div>
    <div class="content-gridless" v-if="this.accountName === null">
        <div class="container ">
            <div class="row align-items-center fill">
                <div class="col align-self-center">
                    <div class="card card-block p-1">
                        <h1 class="m-1 text-center text-muted">
                            <br> Bitte im Menü ein Konto auswählen <br> <br>
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <form v-if="this.accountName !== null">
        <div class="form-row">
            <div class="col-4">
                <label for="name">Kontoname</label>
                <input
                    v-model="t_newName"
                    type="text"
                    class="form-control"
                    id="name"
                    placeholder="Kontoname"
                    title="Eindeutiger Kontoname"
                    @keydown.enter.prevent
                >
            </div>
        </div>
        <div class="form-row">
            <div class="col-4">
                <label for="groupMembership">Gruppe</label>
                <select
                    v-model="t_groupMembership"
                    class="custom-select"
                    title="Mitglieder dieser Gruppe"
                    id="groupMembership">
                    <option value=0 selected>Gruppe auswählen...</option>
                    <option v-for="item_name in user_group_list" :key="item_name" :value="item_name">
                        {{ item_name }}
                    </option>
                    
                </select>
            </div>
        </div>
        <div class="form-row d-flex justify-content-end">
            <div class="p-0">
                <a v-on:click="perform('SAVE')" v-on:submit.prevent="onSubmit" class="btn btn-success" href="#" role="button">
                    Konto speichern
                </a>
            </div>
        </div>
        <div class="form-row d-flex justify-content-end">
            <div class="p-0">
                <a v-on:click="perform('DELETE')" v-on:submit.prevent="onSubmit" class="btn btn-danger" href="#" role="button">
                    Konto löschen
                </a>
            </div>
        </div>
        
    </form>
</div>
</template>

<script>
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import {en, de} from 'vuejs-datepicker/dist/locale'

export default {
    name: 'EditFinAccount',
    components: {
        Datepicker
    },
    data() {
        return {
            error_msg: 'No Error',
            t_name: '',
            t_newName: '',
            t_groupMembership: '',
            en: en,
            de: de,
        }
    },
    methods: {
        perform(actionType) {
            if (actionType === "SAVE"){
                if (!confirm('Konto speichern?')) {
                    return;
                }

                const data = new FormData();
                data.append('newName', this.t_newName);
                data.append('groupMembership', this.t_groupMembership);
                data.append('actionType', actionType);
                console.log( this.t_date);
                let credentials = JSON.parse(localStorage.getItem('credentials'))
                
                axios({
                    url: process.env.VUE_APP_ROOT_API
                        + '/accounts/' + this.t_name,
                    data: data,
                    auth: credentials,
                    method: 'put'
                })
                .catch(e => {
                    console.log(e);
                })
                .then(resp => {
                    let msg = resp.data;
                    console.log("Message");
                    console.log(msg);
                    if (msg) {
                        console.log("Pushing message");
                        this.$store.commit('add_message', msg);
                        if (msg.type !== "ERROR") {
                            this.$store.dispatch('loadData');
                        }
                    }
                });
            } else if (actionType === "DELETE") {
                if (!confirm('Konto löschen?')) {
                    return;
                }

                const data = new FormData();
                data.append('actionType', actionType);
                console.log( this.t_date);
                let credentials = JSON.parse(localStorage.getItem('credentials'))
                axios({
                    url: process.env.VUE_APP_ROOT_API
                        + '/accounts/' + this.t_name,
                    data: data,
                    auth: credentials,
                    method: 'delete'
                })
                .catch(e => {
                    console.log(e);
                })
                .then(resp => {
                    let msg = resp.data;
                    console.log("Message");
                    console.log(msg);
                    if (msg) {
                        console.log("Pushing message");
                        this.$store.commit('add_message', msg);
                        if (msg.type !== "ERROR") {
                            this.t_name = '';
                            this.t_groupMembership = '';
                            this.$store.commit('switch_account', null);
                            this.$store.commit('switch_account_obj', null);
                        }
                    }
                    this.$store.dispatch('loadData');
                });

            }
            
        }
    },
    computed: {
        accountName () {
            if (this.$store.state.current_acc_obj === null) {
                return null;
            }

            console.log("Account obj in EditFinAccount");
            console.log(this.$store.state.current_acc_obj);
            this.t_name = this.$store.state.current_acc_obj.name
            this.t_newName = this.$store.state.current_acc_obj.name
            this.t_groupMembership = this.$store.state.current_acc_obj.group ? this.$store.state.current_acc_obj.group.name : ''
            return this.$store.state.current_acc

        },
        user_group_list() {
            let group_names = []
            this.$store.state.group_list.groups.forEach(group => {
                group_names.push(group.name)
            });
            return group_names
        }
    }
}
</script>

<style scoped>

</style>

